export enum CommonMutationType {
  SET_ORDER_REVIEW = 'SET_ORDER_REVIEW',
  SET_SHIPMENT_PLACES_LIST = 'SET_SHIPMENT_PLACES_LIST',
  SET_ORDER_TRANSPORT_TYPES_LIST = 'SET_ORDER_TRANSPORT_TYPES_LIST',
  SET_ORDER_STATUS_LIST = 'SET_ORDER_STATUS_LIST',
  SET_ORDER_STATUS_LIST_IT = 'SET_ORDER_STATUS_LIST_IT',
  SET_ORDER_DELIVERY_STATUS_LIST_IT= 'SET_ORDER_DELIVERY_STATUS_LIST_IT',
  SET_ORDER_STATUS_CZ = 'SET_ORDER_STATUS_CZ'
}
